import { registerControllers } from "stimulus-vite-helpers";
import application from "./application";

const allControllers = import.meta.globEager("../controllers/**/*_controller.@(ts|js)");
const allComponentControllers = import.meta.globEager("../../components/**/(*_)?controller.@(ts|js)");

registerControllers(application, allControllers);
registerControllers(application, allComponentControllers);
